import { Link } from "react-router-dom";
import type { SalesOrderListAfterSalesBadge as Badge } from "@/lib/sales-order-list-after-sales";

export function SalesOrderListAfterSalesBadge({ badge }: { badge: Badge }) {
  const informational = badge.tone === "info";
  return (
    <Link
      to={badge.href}
      data-testid="sales-order-list-after-sales"
      data-kind={badge.kind}
      data-tone={badge.tone}
      title={badge.label}
      onClick={(event) => event.stopPropagation()}
      className={informational
        ? "mt-1 inline-flex max-w-full items-center gap-1 rounded-md border border-slate-200 bg-slate-50 px-2 py-0.5 text-[11px] font-medium text-slate-600 hover:bg-slate-100"
        : "mt-1 inline-flex max-w-full items-center gap-1 rounded-md border border-amber-300 bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-900 hover:bg-amber-100"}
    >
      <i className={`${informational ? "ri-information-line" : "ri-alarm-warning-line"} shrink-0`} aria-hidden />
      <span className="truncate">{badge.label}</span>
    </Link>
  );
}
